<template>
  <div class="hold-page">
    <section class="hold-list-panel">
      <div class="hold-search">
        <el-input
          v-model="search.keywords"
          size="small"
          clearable
          placeholder="搜索用户/店员手机号或ID"
          @keyup.enter.native="handleSearch"
        >
          <el-button slot="append" type="primary" @click="handleSearch">搜索</el-button>
        </el-input>
      </div>

      <div class="hold-list" v-loading="loading">
        <div
          v-for="item in tableData"
          :key="item.id"
          class="hold-item"
          :class="{active: activeHold && activeHold.id === item.id}"
          @click="activeHold = item"
        >
          <el-avatar :src="memberAvatar(item.member)" :size="44"></el-avatar>
          <div class="hold-item-main">
            <strong>{{ memberName(item.member) }}</strong>
            <span>订单金额：<em>￥{{ money(item.amount) }}</em></span>
          </div>
          <div class="hold-item-side">
            <time>{{ item.ftime }}</time>
            <div>
              <el-button type="text" @click.stop="restore(item)">取单</el-button>
              <el-button type="text" class="danger" @click.stop="remove(item)">删除</el-button>
            </div>
          </div>
        </div>
        <div class="hold-empty" v-if="!loading && !tableData.length">暂无挂单</div>
      </div>

      <el-button
        class="take-btn"
        type="primary"
        :disabled="!activeHold"
        @click="restore(activeHold)"
      >取单 ￥{{ money(activeHold ? activeHold.amount : 0) }}</el-button>
    </section>

    <section class="hold-detail-panel" v-if="activeHold">
      <div class="member-summary">
        <el-avatar :src="memberAvatar(activeHold.member)" :size="52"></el-avatar>
        <div>
          <strong>{{ memberName(activeHold.member) }}</strong>
          <p v-if="!isGuest(activeHold.member)">
            {{ activeHold.member.mobile || '' }}
            <span>余额 <em>{{ money(activeHold.member.balance) }}</em></span>
            <span>积分 <em>{{ activeHold.member.integral || 0 }}</em></span>
          </p>
          <p v-else>散客</p>
        </div>
      </div>

      <div class="detail-head">
        <span>共<em>{{ activeHold.count || goodsCount(activeHold.goods) }}</em>件商品</span>
        <strong>实付：<em>￥{{ money(activeHold.amount) }}</em></strong>
      </div>

      <el-table :data="activeHold.goods" size="mini" class="detail-table">
        <el-table-column label="商品">
          <template slot-scope="scope">
            <div class="detail-goods">
              <img :src="scope.row.img || defaultGoodsImg" />
              <div>
                <strong>{{ scope.row.title }}</strong>
                <span>{{ scope.row.spec_title || '默认' }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="单价" width="140">
          <template slot-scope="scope">{{ money(scope.row.price) }}</template>
        </el-table-column>
        <el-table-column prop="quantity" label="数量" width="140"></el-table-column>
        <el-table-column label="金额" width="140">
          <template slot-scope="scope">{{ money(Number(scope.row.price) * Number(scope.row.quantity)) }}</template>
        </el-table-column>
      </el-table>

      <div class="detail-summary">
        <p>优惠券金额：￥{{ money(couponAmount(activeHold.selectedCoupon, activeHold.goods)) }}</p>
        <p>手工优惠：￥{{ money(activeHold.manualDiscount) }}</p>
        <p>抹零：￥{{ money(activeHold.roundingAmount) }}</p>
        <p v-if="activeHold.remark">备注：{{ activeHold.remark }}</p>
      </div>
    </section>

    <section class="hold-detail-panel empty-detail" v-else>
      请选择左侧挂单
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultAvatar: this.config.SOURCE_DOMAIN + '/images/head.png',
      defaultGoodsImg: this.config.SOURCE_DOMAIN + '/images/default.png',
      loading: false,
      tableData: [],
      activeHold: false,
      search: {
        keywords: '',
        page: 1,
        page_size: 30,
        total: 0
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    money(value) {
      return Number(value || 0).toFixed(2)
    },
    isGuest(member) {
      return !member || Number(member.id || 0) === 0
    },
    memberName(member) {
      if (this.isGuest(member)) return '散客'
      return member.name || member.mobile || member.user_id || '未命名会员'
    },
    memberAvatar(member) {
      return (member && member.avatar) || this.defaultAvatar
    },
    goodsCount(goods) {
      return (goods || []).reduce((sum, item) => sum + Number(item.quantity || 0), 0)
    },
    goodsAmount(goods) {
      return (goods || []).reduce((sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 0), 0)
    },
    couponAmount(coupon, goods) {
      if (!coupon) return 0
      const amount = this.goodsAmount(goods)
      if (Number(coupon.coupon_type) === 1) {
        return Math.min(Number(coupon.coupon_val || 0), amount)
      }
      if (Number(coupon.coupon_type) === 2) {
        const discount = Number(coupon.coupon_val || 10)
        return Math.max(0, amount - amount * discount / 10)
      }
      return 0
    },
    handleSearch() {
      this.search.page = 1
      this.getList()
    },
    getList() {
      this.loading = true
      this.$api.order.orderHoldIndex({
        keywords: this.search.keywords,
        page: this.search.page,
        page_size: this.search.page_size
      }, res => {
        this.loading = false
        if (res.errcode !== 0) {
          this.fail(res.errmsg || '获取挂单失败')
          return
        }
        this.tableData = res.data.data || []
        this.search.total = res.data.total || 0
        this.activeHold = this.tableData[0] || false
      })
    },
    restore(row) {
      if (!row) return
      this.$api.order.orderHoldRestore({id: row.id}, res => {
        if (res.errcode !== 0) {
          this.fail(res.errmsg || '取单失败')
          return
        }
        sessionStorage.setItem('DSHOP_CASHIER_RESTORE', JSON.stringify(res.data))
        this.success('取单成功')
        this.$router.push({name: 'cashier_index'})
      })
    },
    remove(row) {
      this.$confirm('确认删除该挂单吗？', '提示', {type: 'warning'}).then(() => {
        this.$api.order.orderHoldDelete({id: row.id}, res => {
          if (res.errcode !== 0) {
            this.fail(res.errmsg || '删除挂单失败')
            return
          }
          this.success('删除成功')
          this.getList()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.hold-page {
  display: grid;
  grid-template-columns: 420px 1fr;
  gap: 18px;
  height: calc(100vh - 28px);
  min-height: 0;
  overflow: hidden;
}
.hold-list-panel,
.hold-detail-panel {
  min-width: 0;
  min-height: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 14px rgba(20, 40, 70, .06);
}
.hold-list-panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 14px;
}
.hold-search {
  margin-bottom: 12px;
}
.hold-list {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}
.hold-item {
  display: grid;
  grid-template-columns: 44px 1fr 138px;
  gap: 10px;
  padding: 12px 8px;
  border-bottom: 1px solid #edf0f5;
  border-radius: 6px;
  cursor: pointer;
}
.hold-item.active {
  background: #eef7ff;
}
.hold-item-main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.hold-item-main strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.hold-item-main span,
.hold-item-side time {
  color: #667085;
  font-size: 12px;
}
.hold-item-main em,
.detail-head em,
.member-summary em {
  color: #f5222d;
  font-style: normal;
  font-weight: 700;
}
.hold-item-side {
  text-align: right;
}
.hold-item-side .el-button {
  padding: 8px 0 0 10px;
}
.danger {
  color: #f56c6c;
}
.hold-empty {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #98a2b3;
}
.take-btn {
  height: 48px;
  margin-top: 12px;
  border-radius: 24px;
  font-size: 18px;
}
.hold-detail-panel {
  overflow-x: hidden;
  overflow-y: auto;
  padding: 24px;
}
.member-summary {
  height: 96px;
  padding: 0 22px;
  background: #fff8f0;
  display: flex;
  align-items: center;
  gap: 14px;
}
.member-summary strong {
  font-size: 17px;
}
.member-summary p {
  margin: 8px 0 0;
  color: #667085;
}
.member-summary span {
  margin-left: 18px;
}
.detail-head {
  margin: 28px 0 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.detail-head span {
  font-size: 15px;
}
.detail-head strong {
  font-size: 18px;
}
.detail-goods {
  display: flex;
  align-items: center;
  gap: 12px;
}
.detail-goods img {
  width: 54px;
  height: 54px;
  border-radius: 6px;
  object-fit: cover;
  background: #f4f6f8;
}
.detail-goods div {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.detail-goods strong {
  font-weight: 500;
}
.detail-goods span,
.detail-summary {
  color: #667085;
}
.detail-summary {
  margin-top: 18px;
  padding: 14px 22px;
  background: #f8fafc;
  border-radius: 8px;
  line-height: 26px;
}
.detail-summary p {
  margin: 0;
}
.empty-detail {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #98a2b3;
}
</style>
